import React from 'react';
import { Input } from '@ui';

interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  id: string;
  htmlFor?: string;
  label?: React.ReactNode;
  hint?: React.ReactNode;
  hintClassName?: string;
  hintId?: string;
  hintHidden?: boolean;
  className?: string;
}

const Checkbox: React.FC<CheckboxProps> = ({
  id,
  htmlFor: _htmlFor,
  label,
  hint,
  hintClassName,
  hintId,
  hintHidden,
  className = '',
  ...props
}) => {
  return (
    <>
      <label className={['checkbox', className].filter(Boolean).join(' ')}>
        <Input type='checkbox' id={id} name={id} {...props} />
        <span>{label}</span>
      </label>
      {hint ? (
        <small
          id={hintId}
          hidden={hintHidden}
          className={`hint${hintClassName ? ' ' + hintClassName : ''}`}
        >
          {hint}
        </small>
      ) : null}
    </>
  );
};

Checkbox.displayName = 'Checkbox';

export default Checkbox;
